import type { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Wrapper component for page transitions.
 * Currently a simple wrapper - will integrate Motion (Framer Motion) animations later.
 */
export function PageTransition({ children }: PageTransitionProps) {
  // Basic CSS-based fade-in for now
  // Will be enhanced with Motion library in Phase 3
  return (
    <div className="animate-fadeIn">
      {children}
    </div>
  );
}
